<template>
  <div style="height:580px">
    <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;">
      <h5><b>My Policies</b></h5>
    </div>
    <v-data-table
      :headers="headers"
      :items="policies"
      :items-per-page="5"
      class="elevation-1"
    ></v-data-table>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import axios from "axios";

  const URL = "http://139.59.131.242:4000/comp/policiesByClient";

  export default {
    data () {
      return {
        headers: [
          {
            text: 'Insured Name',
            align: 'left',
            sortable: false,
            value: 'insured_name',
          },
          { text: 'Policy No', value: 'transaction_number' },
          { text: 'Product', value: 'product_type_id' },
          { text: 'Client No', value: 'client_id' },
          { text: 'Start Date', value: 'start_date' },
          { text: 'Expiry Date', value: 'end_date' },
          { text: 'Total Premium', value: 'total_premium_due' },
          { text: 'Currency', value: 'currency' },
          { text: 'Date Created', value: 'created_at' }
        ],
        policies:[]
      }
    },
    created(){
      
      const client_id = {
          id :this.user.data.client_id
        }
          
        axios
          .get(URL, { params:client_id })
          .then(response => {
            if (response.status == 200){
              this.policies = response.data;
            }
          })
          .catch(error => {
            console.log('Error', error);
          }); 
    },
    computed: {
      ...mapGetters({
        user: "user"
      })
    }
  }
</script>